<template>
  <div>
    <h1 class="page-header">{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'Cabe',
  props: {
    msg: String
  }
}
</script>
